import Box from '@redbubble/design-system/src/Box';
import styles from './AlsoAvailableOnSectionHeader.module.scss';

export interface AlsoAvailableOnSectionHeaderProps {
  children: React.ReactNode;
}

export const AlsoAvailableOnSectionHeader = ({
  children,
}: AlsoAvailableOnSectionHeaderProps) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      className={styles.container}
      data-testid="aao-header"
    >
      {children}
    </Box>
  );
};
